var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "d-flex justify-space-between",
    attrs: {
      "outlined": _vm.form.isSuccess !== true,
      "width": "150",
      "color": _vm.form.isSuccess === true ? 'primary' : 'grey-d'
    },
    on: {
      "!click": function click($event) {
        return _vm.emit(true);
      }
    }
  }, [_c('span', {
    class: {
      'grey--text': _vm.form.isSuccess != true
    }
  }, [_vm._v(" 채용 ")]), _c('v-simple-checkbox', {
    attrs: {
      "value": _vm.form.isSuccess === true
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
      }
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "d-flex justify-space-between",
    attrs: {
      "outlined": _vm.form.isSuccess !== false,
      "width": "150",
      "color": _vm.form.isSuccess === false ? 'primary' : 'grey-d'
    },
    on: {
      "!click": function click($event) {
        return _vm.emit(false);
      }
    }
  }, [_c('span', {
    class: {
      'grey--text': _vm.form.isSuccess == true
    }
  }, [_vm._v(" 미채용 ")]), _c('v-simple-checkbox', {
    attrs: {
      "value": _vm.form.isSuccess === false
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }